export default {
  currency: 'CAD',
  local: 'fr-CA',
  currencyFloat(num) {
    return Math.round(num * 100) / 100
  },
  format (string) {
    if (string === null || undefined === string || isNaN(string))
      string = '0'

    string = string.toString()
    let formatedString = string.replace(',', '.')
    let formatter = new Intl.NumberFormat(this.local, {
      style: 'currency',
      currency: this.currency,
      minimumFractionDigits: 2
    })
    return formatter.format(formatedString)
  }
}
